import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Pasaré hambre?',
    a: 'No, comerás alimentos densos en nutrientes hasta saciarte.'
  }, {
    q: '¿Necesito equipo especial?',
    a: 'Ninguno, solo ingredientes básicos de supermercado.'
  }, {
    q: '¿Puedo trabajar mientras lo hago?',
    a: 'Sí, de hecho tendrás más claridad mental para hacerlo.'
  }, {
    q: '¿Es seguro?',
    a: 'Es una alimentación basada en comida real y balance mineral natural.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-sage/10 py-24 px-4 border-t border-sage/20" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <h2 className="text-3xl md:text-4xl text-center text-near-black mb-12" data-id="element-16">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-17">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-sage/30 overflow-hidden transition-all duration-200" data-id="element-18">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-19">
                <span className="font-serif text-lg text-near-black" data-id="element-20">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-dark-green transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-21" />
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-22">
                <p className="font-sans text-gray-600" data-id="element-23">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}